import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {LanguageGuard} from './guards/language.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'language',
    pathMatch: 'full'
  },
  {
    path: 'disclaimer',
    loadChildren: () => import('./pages/disclaimer/disclaimer.module').then( m => m.DisclaimerPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'disclaimer/:from',
    loadChildren: () => import('./pages/disclaimer/disclaimer.module').then( m => m.DisclaimerPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'apphints',
    loadChildren: () => import('./pages/apphints/apphints.module').then( m => m.ApphintsPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'references',
    loadChildren: () => import('./pages/references/references.module').then( m => m.ReferencesPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'data-privacy',
    loadChildren: () => import('./pages/data-privacy/data-privacy.module').then( m => m.DataPrivacyPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'indication-search',
    loadChildren: () => import('./pages/indication-search/indication-search.module').then( m => m.IndicationSearchPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'substance-search',
    loadChildren: () => import('./pages/substance-search/substance-search.module').then( m => m.SubstanceSearchPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'atc-search',
    loadChildren: () => import('./pages/atc-search/atc-search.module').then(m => m.AtcSearchModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'icd-search',
    loadChildren: () => import('./pages/icd-search/icd-search.module').then( m => m.IcdSearchPageModule),
    canLoad: [LanguageGuard]
  },
  {
    path: 'language',
    loadChildren: () => import('./pages/language/language.module').then( m => m.LanguagePageModule)
  }




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
